import { Injectable, inject } from '@angular/core';
import { CommunityLinksStrategy } from './community-links-strategy.interface';
import { UserLinksStrategy } from './user-links.strategy';
import { GroupLinksStrategy } from './group-links.strategy';

@Injectable({ providedIn: 'root' })
export class CommunityLinksStrategyService {
  private userStrategy = inject(UserLinksStrategy);
  private groupStrategy = inject(GroupLinksStrategy);

  getStrategy(type: 'user' | 'group'): CommunityLinksStrategy {
    return type === 'user' ? this.userStrategy : this.groupStrategy;
  }
}
